<template>
  <view class="container">
    <view bindtap="scanDualDesc" class="make-order-header"
      >双通道抢票<image
        wx:if="{{pageFrom === 1}}" 
        class="icon"
        mode="aspectFit"
        src="https://ut-static.udache.com/webx/sfc/XNKxsIYqRbUxR384Y6Kfa_clipboard_image_1697628299313.png"
    /></view>
    <view class="wrapper">
      <view wx:for="{{list}}" wx:key="index" class="item">
        <image class="icon" mode="aspectFit" src="{{item.icon}}"></image>
        <view class="info">
          <view class="name">{{ item.name }}</view>
          <view class="tip">{{ item.tip }}</view>
        </view>
        <view class="status">
          <view wx:if="{{item.status === 1}}" bindtap="toOpen" class="off">去开启</view>
          <view wx:if="{{item.status === 2}}" class="on">
            <es-icon class="on-icon" size="12" name="check-circle"></es-icon>已开启<view
              class="detail-btn"
              wx:if="{{item.detail}}"
              bindtap="showDetail"
              >详情<es-icon class="on-icon" size="12" name="angle-right"></es-icon
            ></view>
          </view>
        </view>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { to12306LoginPage, toScanDualDesc } from '@/common/pageJump'

  createComponent({
    props: {
      pageFrom: {   
        type: Number,
        value: 1 // 1填单页 2订单详情页
      }
    },
    computed: {
      ...store.mapState({
        reverseData: 'login12306.reverseData',
        userInfo12306: 'login12306.userInfo12306',
        scrambleTicketInfo: 'order.scramble_ticket_info'
      }),
      houbuStatus() {
        // 1未开通 2已开通
        return (this.reverseData?.data?.cxVip || this.userInfo12306?.cxvip) ? 2 : 1
      },
      list() {
        const orderHoubuStatus = this.pageFrom === 2 && !!this.scrambleTicketInfo?.is_candidate // 历史订单是否开启候补

        let houbuTip = '12306官方候补，成功率更高'
        let houbuDetail = false


        // 订单详情页 并且 订单开启了候补
        if(orderHoubuStatus) {
          // houbuTip = '开售后将自动添加候补车次'
          // else
          houbuTip = this.scrambleTicketInfo?.candidate
            ? '已为您添加候补车次'
            : '正在为您提交候补车次...'
          houbuDetail = true
        }

        const _hbStatus = orderHoubuStatus ? 2 : this.houbuStatus
        
        // 订单详情页 & 订单未开启候补
        const houbuCardHide = this.pageFrom === 2 && !orderHoubuStatus

        const houbuArr = !houbuCardHide
          ? [{
            icon: 'https://ut-static.udache.com/webx/sfc/DpYah9xj_JdCNJWwUrolk_clipboard_image_1697626689844.png',
            name: '候补通道',
            tip: houbuTip,
            detail: houbuDetail,
            status: _hbStatus,
          }]
          : []
        return [
          ...houbuArr,
          {
            icon: 'https://ut-static.udache.com/webx/sfc/HbKpGU2ufA3yyBq2l20ff_clipboard_image_1697626713335.png',
            name: '余票监控',
            tip: '实时查询线路余票，有票秒抢',
            status: 2,
          }
        ]
      },
    },
    methods: {
      ...store.mapMutations({
        verifyCxvip: 'login12306.verifyCxvip',
      }),
      scanDualDesc() {
        if(this.pageFrom !== 1) return 
        toScanDualDesc()
      },
      showDetail() {
        this.triggerEvent('showDetail')
      },
      toOpen() {
        this.verifyCxvip(true)
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .container
    width 100%
    height auto
    border-radius 10px
    background-color #FFFFFF
    line-height 1
    letter-spacing 0
    font-weight normal
    .make-order-header
      height 16px
      padding 16px 14px 0
      display flex
      align-items center
      font-family PingFangSC-Semibold
      font-size 16px
      color #333333
      .icon
        margin-left 3px
        width 16px
        height 16px
    .wrapper
      width 100%
      height auto
      box-sizing border-box
      padding 4px 16px 4px 14px
      background-color #FFFFFF
      border-radius 10px
      .item
        display flex
        align-items center
        height 62px
        position relative
        &:first-child
          &::after
            content ''
            position absolute
            bottom 0
            right 0
            width calc(100% - 42px)
            height 1px
            background-color #f2f6f9
        &:last-child
          &::after
            display none
        .icon, .status
          flex none
        .icon
          width 36px
          height 36px
          margin-right 10px
        .info
          flex 1
          .name
            font-family PingFangSC-Medium
            font-size 14px
            color #333333
          .tip
            font-family PingFangSC-Regular
            font-size 12px
            color #999999
            margin-top 5px
        .status
          .off
            width 54px
            height 24px
            border-radius 5px
            background #FF5900
            display flex
            align-items center
            justify-content center
            font-family PingFangSC-Medium
            font-size 12px
            color #FFFFFF
          .on
            display flex
            align-items center
            font-family PingFangSC-Medium
            font-size 12px
            color #00A442
            &-icon
              margin-right 3px
            .detail-btn
              color #666
              margin-left 12px
              @extend .flex-center
</style>

<script name='json'>
</script>
